<template>
    <div>
        <canvas ref="myChart" :height="height"></canvas>
    </div>
</template>

<script>

    import Chart from '../../../node_modules/chart.js';

    export default {
        name: "TqChart",
        props:{
            datasets : {
                require : true,
                type : Array
            },
            p_labels_as:{
                require: true,
                type: Array,
            },
            type:{
                require : true,
                type : String
            },
            height:{
                require : true,
                type : Number
            },
            p_xAxes_ao:{
                type : Array,
                default : () => {
                    return [{
                        type: 'time',
                        time: {
                            unit: 'day'
                        },
                    }]
                }
            },
            p_yAxes_ao: {
                type : Array,
                default : ()=> {
                    return[
                        {
                            id: 'Profit',
                            scaleLabel: {
                                labelString: 'Profit'
                            },
                            ticks: {
                                min: 0,
                            }
                        },
                        {
                            position: 'right',
                            id: 'Players',
                            scaleLabel: {
                                labelString: 'Players'
                            },
                            ticks: {
                                min: 0,
                            }
                        }]
                }
            }
        },
        data(){
            return {
                myChart : null,
            }
        },
        methods : {
            m_refreshData_f(){
                this.myChart.data.datasets = this.datasets
                if(this.p_labels_as){
                    this.myChart.data.labels = this.p_labels_as
                }
                this.myChart.update()
            }
        },

        watch :{
            datasets :{
                handler(){
                    this.m_refreshData_f()
                },
            },
            p_lables_as :{
                handler(){
                    this.m_refreshData_f()
                },
            },
        },

        mounted(){
            switch(this.type){

                case 'line':
                    this.myChart = new Chart(this.$refs.myChart, {
                        type: 'line',
                        data : {
                            datasets: this.datasets
                        },
                        options: {
                            scales: {
                                xAxes: this.p_xAxes_ao,
                                yAxes: this.p_yAxes_ao
                            },
                            legend: {
                                display: true,
                                position: 'bottom',
                                labels: {
                                    fontSize: 20,
                                    // boxWidth: 2,
                                }
                            },
                            tooltips: {
                                mode: 'index',
                                titleFontSize: 14,
                                titleMarginBottom: 8,
                                callbacks: {
                                    title: function(tooltipItems, data) {
                                        //Return value for title
                                        return data.datasets[tooltipItems[0].datasetIndex].data[tooltipItems[0].index].title
                                    },
                                    // label: function(tooltipItem, data) {
                                    //     // console.log(tooltipItem)
                                    //     return data.datasets[tooltipItem.datasetIndex].label + tooltipItem.yLabel;
                                    //     // return formatDate_hour(date_newDate_fd(tooltipItem.xLabel).getTime());
                                    // },

                                }
                            }
                        }
                    });
                    break;
                case 'doughnut':


                    this.myChart = new Chart(this.$refs.myChart, {
                        type: this.type,
                        data : {
                            datasets    : this.datasets,
                            labels      : this.p_labels_as,
                        },
                        options: {
                            tooltips: {
                                callbacks: {
                                    title: function(tooltipItems, data) {
                                        return data.datasets[tooltipItems[0].datasetIndex].label
                                    },
                                    // label: (item, data) => {
                                    //     return data.datasets[item.datasetIndex].label + ": " + data.labels[item.index] + ": " + data.datasets[item.datasetIndex].data[item.index];
                                    // }
                                }
                            }
                        }


                    });
                    break;

                case 'bar':
                    this.myChart = new Chart(this.$refs.myChart, {
                        type: 'bar',
                        data: {
                            datasets: this.datasets,
                            labels : this.p_labels_as
                        },
                        options: {
                            title: {
                                display: false,
                            },
                            scales: {
                                yAxes: [{
                                    display: true,
                                    ticks: {
                                        suggestedMin: 0,    // minimum will be 0, unless there is a lower value.
                                    }
                                }]
                            }
                        }
                    });

                    break;

            }
        },



    }
</script>

<style scoped>

</style>